module.exports = __webpack_public_path__ + "media/Tigre.55b52072.mp3";